import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useDataDog } from './useDataDog';
import {
  extractFieldErrorsFromNativeFormError,
  extractFieldErrorsFromWidgetErrorKeys,
  FORM_VALIDATION_ERROR_NAME,
  FORM_VALIDATION_ERROR_TYPE,
  getInvalidFormFields,
} from './logger.util';

function useFormValidationLogger() {
  const { notifyErrorToDataDog } = useDataDog();
  const leadData = useSelector((state) => state?.lead?.leadData);

  const trackNativeFormValidationErrors = useCallback(
    (formRef) => {
      if (!formRef?.current) return;

      const form = formRef.current;
      const invalidFields = getInvalidFormFields(form);

      if (invalidFields.length < 1) return;

      const nativeFieldErrors = extractFieldErrorsFromNativeFormError(form, invalidFields);

      notifyErrorToDataDog(FORM_VALIDATION_ERROR_NAME, {
        validationErrors: {
          type: FORM_VALIDATION_ERROR_TYPE.NATIVE,
          formFields: nativeFieldErrors,
        },
      });
    },
    [notifyErrorToDataDog]
  );

  const trackCustomFormValidationErrors = useCallback(
    (widgetValidationErrors) => {
      const widgetErrors = Object.keys(widgetValidationErrors);
      const errorFields = extractFieldErrorsFromWidgetErrorKeys(widgetErrors, leadData);

      if (errorFields.length < 1) return;

      notifyErrorToDataDog(FORM_VALIDATION_ERROR_NAME, {
        validationErrors: {
          type: FORM_VALIDATION_ERROR_TYPE.CUSTOM,
          formFields: errorFields,
        },
      });
    },
    [leadData, notifyErrorToDataDog]
  );

  return { trackNativeFormValidationErrors, trackCustomFormValidationErrors };
}

export default useFormValidationLogger;
